// export default Home
import React, { useEffect, useState, useRef, useCallback } from 'react';

import Navbar from './../../components/Navbar/Navbar';
import Hero from './../../components/Hero/Hero';
import About from './../../components/About/About';
import Services from './../../components/Services/Services';
import Portfolio from './../../components/Portfolio/Portfolio';
import Contact from './../../components/Contact/Contact';
import Footer from './../../components/Footer/Footer';

import "./Home.css";

import TextRoller from './../../components/TextRoller/TextRoller';
import ScrollNav from './../../components/ScrollNav/ScrollNav';

import mouse from "./../../Assets/mouse.png";

import Lenis from "lenis";

function Home() {

    const heroRef = useRef(null);
    const aboutRef = useRef(null);
    const servicesRef = useRef(null);
    const portfolioRef = useRef(null);
    const contactRef = useRef(null);
    const footerRef = useRef(null);

    const sections = React.useMemo(() => [
        { id: "home", ref: heroRef },
        { id: "about", ref: aboutRef },
        { id: "services", ref: servicesRef },
        { id: "portfolio", ref: portfolioRef },
        { id: "contact", ref: contactRef },
        { id: "footer", ref: footerRef }
    ], []);

    const lenisRef = useRef();

    const [showScrollbar, setShowScrollbar] = useState(
        !!sessionStorage.getItem("homeVisited")
    );
    const [showMouse, setShowMouse] = useState(false);

    const textRef = useRef(null);

    const [fadeOut, setFadeOut] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    const [showIntro] = useState(
        !sessionStorage.getItem("homeVisited")
    );


    useEffect(() => {

        lenisRef.current = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            direction: "vertical",
            gestureDirection: "vertical",
            smooth: true,
            smoothTouch: false,
            touchMultiplier: 2,
        });

        function raf(time) {
            lenisRef.current.raf(time);
            requestAnimationFrame(raf);
        }

        const animationId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(animationId);

            if (lenisRef.current) {
                lenisRef.current.destroy();
            }
        };

    }, []);

    // useEffect(() => {

    //     const hasVisited = sessionStorage.getItem("homeVisited");

    //     if (hasVisited) {
    //         setShowScrollbar(true);
    //         return;
    //     }

    //     sessionStorage.setItem("homeVisited", "true");

    //     const timer = setTimeout(() => {
    //         setShowScrollbar(true);
    //     }, 5500);

    //     return () => clearTimeout(timer);

    // }, []);

    // useEffect(() => {

    //     const textCompleteTime = 3000;

    //     setTimeout(() => {
    //         setShowMouse(true);
    //     }, textCompleteTime);

    //     const fadeDelay = textCompleteTime + 1500;

    //     setTimeout(() => {
    //         setFadeOut(true);
    //     }, fadeDelay);

    // }, []);

    useEffect(() => {

        if (!showIntro) return;

        sessionStorage.setItem("homeVisited", "true");

        const timer = setTimeout(() => {
            setShowScrollbar(true);
        }, 5500);

        return () => clearTimeout(timer);

    }, [showIntro]);

    useEffect(() => {

        if (!showIntro) return;

        const mouseTimer = setTimeout(() => {
            setShowMouse(true);
        }, 3000);

        const fadeTimer = setTimeout(() => {
            setFadeOut(true);
        }, 4500);

        return () => {
            clearTimeout(mouseTimer);
            clearTimeout(fadeTimer);
        };

    }, [showIntro]);

    const handleScroll = useCallback(() => {

        const scrollPosition = window.scrollY + window.innerHeight / 2;

        sections.forEach((sec, index) => {

            const element = sec.ref.current;

            if (!element) return;

            const { offsetTop, offsetHeight } = element;

            if (index === sections.length - 1) {

                const bottomOffset =
                    document.documentElement.scrollHeight -
                    window.innerHeight -
                    10;

                if (window.scrollY >= bottomOffset) {
                    setActiveIndex(index);
                    return;
                }
            }

            if (
                scrollPosition >= offsetTop &&
                scrollPosition < offsetTop + offsetHeight
            ) {
                setActiveIndex(index);
            }

        });

    }, [sections]);

    useEffect(() => {

        window.addEventListener("scroll", handleScroll);

        return () =>
            window.removeEventListener("scroll", handleScroll);

    }, [handleScroll]);

    return (
        <>
            {showIntro && (
                <div className={`abs_ani_con ${showScrollbar ? "show-scrollbar" : "hide-scrollbar"} ${fadeOut ? 'fade-out' : ''}`}>

                    <TextRoller
                        finalText="The Scroll Buzz"
                        duration={60}
                        ref={textRef}
                    />

                    <div className={`mouse-wrapper ${showMouse ? 'visible' : ''}`}>
                        <img
                            src={mouse}
                            alt="Scroll prompt"
                            className="mouse-icon"
                        />
                    </div>

                    <div className="absolute_animation_container_left"></div>
                    <div className="absolute_animation_container_right"></div>

                </div>
            )}

            {showScrollbar && (
                <ScrollNav
                    activeIndex={activeIndex}
                    sections={sections}
                />
            )}

            <div className={`app ${showScrollbar ? "show-scrollbar" : "hide-scrollbar"}`}>

                <Navbar sections={sections} />

                <section ref={sections[0].ref}>
                    <Hero />
                </section>

                <section ref={sections[1].ref}>
                    <About />
                </section>

                <section ref={sections[2].ref}>
                    <Services />
                </section>

                <section ref={sections[3].ref}>
                    <Portfolio />
                </section>

                <section ref={sections[4].ref}>
                    <Contact />
                </section>

                <section ref={sections[5].ref}>
                    <Footer />
                </section>

            </div>
        </>
    );
}

export default Home;